import React, { useContext, useEffect } from "react";
import { useRef, useState } from "react";
import { Form, Button, Row, Col, Table } from "react-bootstrap";
import API_BASE_URL from "../../config";
import { io } from "socket.io-client";
import { AuthContext } from "../../utility/AuthContext";

function PatientSearch({ setLoader, setSearch, setId, name, url }) {
  const [patientList, setPatientList] = useState([]);
  const { user } = useContext(AuthContext);
  const socket = io(API_BASE_URL);

  useEffect(() => {
    socket.on("patient-test-list", (data) => setPatientList(data.patient_list));
    socket.emit("patient-test-list");
    return () => socket.off("patient-test-list");
  }, [user]);

  return (
    <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="container bg-white p-4 rounded shadow-sm">
        <h5 className="mb-3">{name}</h5>

        <Table striped bordered hover>
          <thead>
            <tr>
              <th style={{ width: "100px" }}>Action</th>
              <th>Name</th>
              <th>Contact Number</th>
            </tr>
          </thead>
          <tbody>
            {patientList.length === 0 ? (
              <tr>
                <td colSpan="3" className="text-center">
                  No records found
                </td>
              </tr>
            ) : (
              patientList.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Button
                      variant="info"
                      onClick={() => {
                        setSearch(false);
                        setId(item.id);
                      }}
                    >
                      VIEW
                    </Button>
                  </td>
                  <td>{item.name}</td>
                  <td>{item.contact}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default PatientSearch;
